import React from "react";
import { useSelector } from "react-redux";
import { object, string } from "prop-types";
import get from "lodash/get";

import MagazineWidget from "../../../arrow/components/Rows/MagazineWidget";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { useTrackWidgetImpression } from "../../../ga-utils";

import "./from-our-magazines.m.css";

export const FromOurMagazines = ({ collection, pageType }) => {
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const {
    enableEditionsTitle = true,
    rowTitle = "From Our Magazine",
    showRowTitle = true,
  } = get(collection, ["associated-metadata"], {});

  const contextConfig = {
    enableEditionsTitle,
    rowTitle,
    showRowTitle,
    showBottomReadMore: !isDesktop,
    showTitleReadMore: isDesktop,
    magazineSlug: `magazine/${collection.slug}`,
  };

  // Track widget impression using the hook
  const isBrowser = typeof window !== "undefined";
  const trackingOptions = {
    sectionName: rowTitle,
    pageType: pageType,
    location: isBrowser ? window.location : {},
    config: qtState.config,
    threshold: 0.2,
  };
  const componentRef = useTrackWidgetImpression(trackingOptions);

  return (
    <div styleName="latest-magazine-issues" ref={componentRef}>
      <MagazineWidget
        collection={collection}
        config={contextConfig}
        limit={5}
        showLoadmore={true}
        pageType={pageType}
      />
    </div>
  );
};

FromOurMagazines.propTypes = {
  collection: object,
  pageType: string,
};

FromOurMagazines.defaultProps = {
  pageType: "",
};
